<template>
	<div class="toc_tree">
	
		<div class="tree_node">
			<button v-b-toggle="'nodeRow_' + node.title" class="icon_container btn_transprnt" :disabled="structure && structure.length === 0">
				<span class="icon icon-collapse" aria-label="collapse"><span class="visibility_hide">collapse</span></span>
				<span class="icon icon-expand" aria-label="expand"><span class="visibility_hide">expand</span></span>
			</button>
			<b-link v-b-toggle="'nodeRow_' + node.title" class="title_container">
				<span class="entity_icon" :class="'icon-' + node.entityType"></span>
				<span class="category_title" v-if="node.entityType == 'folder'" @click="changeCategory(node)" :title="node.title">{{ node.title }}</span>
				<span class="title_entity" v-else @click="changeEntity(node)" :title="node.title" :class="'status_'+statusClass(node.courseStatus)">{{ node.title }}</span>
			</b-link>
			<!--
			<span class="credit-progress"><span class="result-success"></span></span>
			-->
		</div>

		<div class="inner_level">
			<b-collapse :id="'nodeRow_' + node.title">
				<ul v-if="structure && structure.length > 0" style="position:relative;">
					<div class="strip-column"></div>
	      			<node-category v-for="substream in structure" v-if="substream.entityType !== 'courseOptions'" :node="substream"></node-category>
	    		</ul>
			</b-collapse>
		</div>

	</div>
</template>

<script>
import '../../../assets/module/css/common/pgLftCategoryTree.min.css'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'nodeCategory',
  props: ['node', 'isCategoryView'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadStreamEntity',
      'loadCategory'
    ]),
    changeEntity (entity) {
      if (entity.entityType !== 'folder') {
        this.loadStreamEntity(entity)
      }
    },
    changeCategory (category) {
      this.loadCategory(category)
    },
    statusClass (status) {
      if (status === 0) {
        return 'NOT_STARTED'
      } else if (status === 1) {
        return 'INPROGRESS'
      } else if (status === 2) {
        return 'COMPLETED'
      } else if (status === 3) {
        return 'TRANSFERRED'
      } else {
        return ''
      }
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream
    }),
    structure () {
      if (this.node && this.node.contentViewStructure) {
        return JSON.parse(this.node.contentViewStructure)
      } else {
        return []
      }
    }
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/stream/components/NodeCategoryTree.vue